module.exports = __webpack_public_path__ + "img/shadow-triangle-grey.70e32625.svg";